import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const AccountHealth = () => import('./Index.vue');

/**
 * Administrator-only, and not merely by convention.
 *
 * Three of the sixteen checks read fields the API serializes exclusively for administrators —
 * microsoft_reauthorization on an email inbox, and both membership probes, which an agent is not
 * authorized to make. An agent opening this page would be shown a confident all-clear assembled
 * out of requests that were refused.
 */
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/health'),
      component: SettingsContent,
      props: {
        headerTitle: 'ACCOUNT_HEALTH.HEADER',
        icon: 'search-check',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'account_health_index',
          component: AccountHealth,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
